/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {
        username: null,
        socketId: null,
        role: null,
    },
    engines: {
        list: [],
        selected: [],
    },
    activeUsers: [],
};

const userSlice = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {
        initializeUser: (state, action) => {
            const { username, socketId } = action.payload
            state.data.username = username
            state.data.socketId = socketId
        },
        updateUser: (state, action) => {
            state.data = action.payload
        },
        setEngines: (state, action) => {
            state.engines.list = action.payload
        },
        updateEngine: (state, action) => {
            const updatedEngine = action.payload
            state.engines.list = state.engines.list.map((engine) => 
                engine.id === updatedEngine.id ? updatedEngine : engine)
        },
        setChecked: (state, action) => {
            state.engines.selected = action.payload
        },
        loadRemoteEnginesStack: (state, action) => {
            const { list, selected } = action.payload
            state.engines.list = list
            state.engines.selected = selected
        },
        addActiveUser: (state, action) => {
            if (Array.isArray(action.payload))
                state.activeUsers.push(...action.payload)
            else state.activeUsers.push(action.payload)
        },
        removeActiveUser: (state, action) => {
            state.activeUsers = state.activeUsers.filter(user => user.socketId !== action.payload.socketId)
        }
    }
});

export const {
    loadRemoteEnginesStack,
    addActiveUser,
    removeActiveUser,
    initializeUser,
    updateEngine,
    updateUser,
    setEngines,
    setChecked,
} = userSlice.actions;

export default userSlice;
